import React, { Component } from 'react';
//import FontAwesomeIcon from 'react-fontawesome';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './App.css';

import DemoBrowser from './components/DemoBrowser/DemoBrowser';
import Sidebar from './components/Sidebar/Sidebar';
import EquipBrowser from './components/EquipBrowser/EquipBrowser';

import fire from './fire';

var barStyle = {
  backgroundColor: '#445753',
  maxWidth: '340px',
  minWidth: '260px',
  display: 'block',
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      showDock: true,
      appFlexDirection: 'row',
      width: 778,
      height: 0,
      demos: [],
      oldDemos: [],
      selectedButtons: [],
      query: '',
      shouldFocus: false,
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  // keeps track of how big the window is
  // so we can respond immediately
  // then get the information from the database
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this._resizeApp();

    // get the information from the back end
    fire.ref('demos/stolaf').once('value')
      .then((snapshot) => {
        let items = snapshot.val();
        let newState = [];
        for (let item in items) {
          newState.push({
            id: item,
            title: items[item].title,
            video: items[item].video,
            cat: items[item].cat,
            status: items[item].status,
            img: items[item].img,
            contact: items[item].contact
          });
        }
        this.setState({ demos: newState, oldDemos: newState });
      });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight }, this._resizeApp);
  }

  _filterDemos = (incomingState) => {
    var newState = [];

    // make sure that we always default to returning everything
    // incase everything has been deselected
    console.log("INCOMING STATE: " + incomingState);
    if(incomingState.length === 0) {
      this.setState({ demos: this.state.oldDemos, selectedButtons: incomingState });
      return;
    }
    for (var i = 0, len = this.state.oldDemos.length; i < len; i++) {
      if(incomingState.includes(this.state.oldDemos[i].cat)) {
        newState.push(this.state.oldDemos[i]);
        //console.log(this.state.demos[i]);
      }
    }
    this.setState({ demos: newState, selectedButtons: incomingState });
  }

  // something was entered into the search field
  // so return demos that look like that
  // TODO: when searching, it returns all demos that match,
  // not the ones that have been sorted first
  _searchForDemos = (name) => {
    console.log("name: " + name);
    this.setState({ query: name, shouldFocus: true });

    var newState = [];
    for (var i = 0, len = this.state.oldDemos.length; i < len; i++) {
      if(this.state.oldDemos[i].title.toLowerCase().includes(name.toLowerCase())) {
        newState.push(this.state.oldDemos[i]);
      }
    }
    this.setState({ demos: newState });
  }

  // changes appropriate states to redraw app
  // so that it looks nice in browser
  _resizeApp = () => {
    if(this.state.width < 750) {
      this.setState({ showDock: false,  appFlexDirection: 'column'});
      barStyle.display = 'none';
    } else {
      this.setState({ showDock: true, appFlexDirection: 'row' });
      barStyle.display = 'block';
    }
  }


  // TODO: this and resizeApp can probably be optimized further
  _showDock = () => {
    if(barStyle.display === 'block') {
      barStyle.display = 'none';
      this.setState({ showDock: false });
    } else {
      barStyle.display = 'block';
      this.setState({ showDock: true });
    }
  }

  render() {
    // TODO: make Sidebar respond to mobile layouts
    const routes = [
      {
        path: '/demos',
        exact: true,
        sidebar: () => <Sidebar
          title='Demonstrations'
          sortFunction={this._filterDemos}
          searchFunction={this._searchForDemos}
          searchValue={this.state.query}
          shouldSearchFocus={this.state.shouldFocus}
          selectedButtons={this.state.selectedButtons}
          navTitle='Equipment'
          navLink='equipment'/>,
        main: () => <DemoBrowser demos={this.state.demos} />
      },
      {
        path: '/equipment',
        exact: true,
        sidebar: () => <Sidebar
          title='Equipment'
          selectedButtons={[]}
          navTitle= 'Demonstrations'
          navLink='demos'/>,
        main: () => <EquipBrowser />
      }
    ]

    return (
      <Router>
      <div className="App" style={{flexDirection: this.state.appFlexDirection}}>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.sidebar}
          />
        ))}
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.main}
          />
        ))}
    </div>
    </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js